import { Fragment, createRef, useContext, useEffect, useRef, useState } from 'react';
import "./ImageViewer.css";

import { AdvancedFormGroup } from '../AdvancedFormGroup/AdvancedFormGroup';
import { RenderScrollContext } from '../../contexts/RenderScrollContext';
import { AdditionalSignaturesContext } from '../../contexts/AdditionalSignaturesContext';
import { SignatureBox } from '../SignatureBox/SignatureBox';
import DocumentPage from '../DocumentPage/DocumentPage';
import DocumentMapService from '../../services/DocumentMapService';

export const ImageViewer = (props) => {

  const { form } = props;
  const { documentRendered: images } = useContext(RenderScrollContext);
  const lineRefs = useRef([]);
  const [resolvedImagesList, setResolvedImagesList] = useState([]);
  const [pageOrientations, setPageOrientations] = useState({});
  const hasForm = form?.FormDisplay;
  const isOnPreviewForm = hasForm && form?.FormDisplay.toLowerCase() === "onpreview";

  lineRefs.current = images?.map((_, i) => lineRefs.current[i] ?? createRef());

  const { signatureBoxes } = useContext(AdditionalSignaturesContext);

  const getPagePercentage = (pageWidth) => {
    const highestWidth = Math.max(...images.map((image) => image.Width || 210));
    const percentage = (pageWidth / highestWidth) * 100;
    return percentage;
  }

  useEffect(() => {
    const loadedPages = DocumentMapService.getLoadedValues();

    const fetchImagesList = async () => {
      const imagesListPromises = images?.map(async (renderedImage, index) => {
        const page = loadedPages[index] + 1;

        let signatureBoxesData = signatureBoxes ? signatureBoxes : [];

        signatureBoxesData = signatureBoxesData.filter((box) => box.Page === page);

        const base64Image = renderedImage.RenderedPageB64;

        const imageSrc = `data:image/jpeg;base64,${base64Image}`;

        const imageInfo = {
          Width: renderedImage.Width || 210, // Default A4 size
          Height: renderedImage.Height || 297, // Default A4 size
          RenderedPageB64: base64Image,
        };

        const signatureBoxesOfPage = signatureBoxesData.map((box, i) => {
          return <SignatureBox boxData={box} key={i} pageWidth={imageInfo.Width} pageHeight={imageInfo.Height} pagePercentage={getPagePercentage(imageInfo.Width)} />;
        });

        return (
          <Fragment key={page}>
            <DocumentPage
              srcImage={imageSrc}
              index={page}
              form={form}
              lineRef={lineRefs.current[index]}
              zoomStyles={props.zoomStyles}
              signatureBoxesOfPage={signatureBoxesOfPage}
              isOnPreviewForm={isOnPreviewForm}
              imageInfo={imageInfo}
              onOrientationChange={(isHorizontal) => {
                setPageOrientations(prev => {
                  if (prev[index] === isHorizontal) return prev;
                  return { ...prev, [index]: isHorizontal };
                });
              }}
            >
              {form && <AdvancedFormGroup pageWidth={imageInfo.Width} index={page - 1} pagesLength={images.length} isHorizontal={pageOrientations[index]} />}
              {signatureBoxesOfPage}
            </DocumentPage>
          </Fragment>
        );
      });

      const resolvedList = await Promise.all(imagesListPromises);
      setResolvedImagesList(resolvedList);
    };

    fetchImagesList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [images, form, signatureBoxes, props.zoomStyles]);

  return (
    <>
      {resolvedImagesList}
    </>
  );
}